import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * This component is responsible for the display of standardized footer actions
 *
 * @export
 */
@Component({
    selector: 'intello-dialog-footer',
    templateUrl: './dialog-footer.component.html',
    styleUrls: ['./dialog-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogFooterComponent { }

